import { Col, Input, Label } from "reactstrap";
import { InlineCheckbox } from "../../../../Constant";
import { INLINE_CHECHBOX } from "../../../../Data/FormControl/CheckboxAndRadio";
import { H6 } from "../../../../AbstractElements";

export const InlineCheckboxs = () => {
  return (
    <Col md="6" xl="4">
      <div className="card-wrapper border rounded-3 checkbox-checked">
        <H6 className="sub-title">{InlineCheckbox}</H6>
        <div className="form-check-size rtl-input">
          <div className="form-check form-check-inline">
            <Input className="me-2" id="inlineCheckbox1" type="checkbox" defaultChecked />
            <Label htmlFor="inlineCheckbox1" check>I</Label>
          </div>
          {INLINE_CHECHBOX.map(({ id, text, disabled }, index) => (
            <div className="form-check form-check-inline" key={index}>
              <Input className="me-2" id={id} type="checkbox" disabled={disabled} />
              <Label htmlFor={id} check>
                {text}
              </Label>
            </div>
          ))}
        </div>
      </div>
    </Col>
  );
};
